module.exports = __webpack_public_path__ + "static/media/youtube_widget.c0d6d0dd.png";